export function formatPrix(value: number | null): string {
  if (value === null || isNaN(value)) return '—';
  return value.toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatTotalHT(quantite: number | null, prixUnitaire: number | null): string {
  if (quantite === null || prixUnitaire === null) return '—';
  return formatPrix(quantite * prixUnitaire);
}

export function computeTotalHT(quantite: number | null, prixUnitaire: number | null): number | null {
  if (quantite === null || prixUnitaire === null) return null;
  return quantite * prixUnitaire;
}
